import React, { createContext, useContext, useEffect, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import PropTypes from "prop-types";
import Cover from "app/auth/index";
import Login from "app/auth";
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);

    const onLoginSuccess = (tokenResponse) => {
        localStorage.setItem('googleToken', tokenResponse.credential);
        // Fetch user information using the tokenResponse
        setCurrentUser(tokenResponse);
    }

    useEffect(() => {
        const token = localStorage.getItem('googleToken');

        if (token) {
            const decodedToken = jwtDecode(token);
            //console.log("decodedToken", decodedToken);
            const currentTime = Date.now() / 1000; // Current time in seconds

            if (decodedToken.exp > currentTime) {
                // Fetch user information using the token
                setCurrentUser({ credential: token });
            }
        }
    }, []);

    const login = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            // Store the token securely
            onLoginSuccess(tokenResponse);
        },
        onError: () => {
            console.log("Login Failed");
        },
        scope: 'openid email profile',
        responseType: 'id_token token',
        nonce: 'random-string' // Include a nonce parameter
    });

    return (
        <AuthContext.Provider value={{ currentUser, login }}>
            {currentUser ?
                (children)
                :
                <Login onLogin={onLoginSuccess}></Login>
            }
        </AuthContext.Provider>
    );
};


AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};


